/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GenerateEmploymentPasscodeRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GenerateEmploymentPasscodeResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const generateEmploymentPasscode = (request: GenerateEmploymentPasscodeRequest, options?: CashRequestOptions) => post<GenerateEmploymentPasscodeRequest, GenerateEmploymentPasscodeResponse>("/2.0/cash/generate-employment-passcode", request, {...options, rejectOnError: true })